/** @format */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  FormLabel,
  FormCheck,
  Modal,
} from "react-bootstrap";
import JobPostingForm from "../../profiles/emp-profile/job-list/job-posting-form";
import ToastNotification from "../../../../components/toast-notification";
import FPG from "src/assets/images/fpg.png";
import background from "src/assets/images/9926.jpg";
import { useGetJobMeCompany } from "../../../../api/queries/job.query";

const EmpDashboard = () => {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const handleShowToast = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000); // Auto-hide after 3 seconds
  };

  const { data: allJob, isLoading: isLoadingAllJob } = useGetJobMeCompany({
    select: (response) => response.data.jobs,
  });

  console.log(allJob);

  return (
    <div
      id="content-page"
      className="content-inner"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
        overflowY: "auto",
      }}
    >
      <Container className="pb-5">
        <div className="birthday-block">
          <Row>
            <Card className=" border border-secondary-subtle">
              <Card.Body>
                <div className="iq-birthday-block">
                  <div className="d-flex align-items-center justify-content-between">
                    <div
                      className="d-flex align-items-center"
                      style={{ height: "100px" }}
                    >
                      <Link to="#">
                        <img
                          src={FPG}
                          alt="profile-img"
                          className="img-fluid"
                          style={{ height: "100px" }}
                        />
                      </Link>
                      <div className="friend-info ms-md-5 mt-md-0 mt-2">
                        <h2>First Pavilion Global Berhad</h2>
                        <p className="mb-0">Information & Technology Company</p>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary me-4"
                      onClick={handleOpenModal}
                    >
                      Post Your Job
                    </button>
                    <Modal
                      show={showModal}
                      onHide={handleCloseModal}
                      centered
                      size="lg"
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Post Your Job</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <JobPostingForm
                          onFormSubmit={handleCloseModal}
                          showToast={handleShowToast}
                        />
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </Card.Body>
            </Card>
            <ToastNotification
              message={toastMessage}
              show={showToast}
              onClose={() => setShowToast(false)}
            />
          </Row>
          <div
            className="mb-4 badge bg-success text-wrap text-white"
            style={{ width: "13rem" }}
          >
            <h4 style={{ color: "white" }}>Active Job Post</h4>
          </div>
          {isLoadingAllJob ? (
            <p>Loading...</p>
          ) : allJob ? (
            allJob?.map((job) => (
              <Card
                key={job?.id}
                className="border border-secondary-subtle mb-4"
              >
                <CardBody className="d-flex justify-content-between align-items-center mb-0">
                  <div>
                    <Link to="/e/candidate" className="mb-0 fs-3 text-black">
                      {job?.title}
                    </Link>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="material-symbols-outlined me-2">
                      calendar_month
                    </span>
                    <h6 className="mb-0">Expires: {job?.expiry}</h6>{" "}
                  </div>
                  <div className="d-flex align-items-center">
                    <FormLabel className="me-2 mb-0">Live</FormLabel>
                    <FormCheck
                      type="switch"
                      id="flexSwitchCheckDefault"
                      defaultChecked
                    />
                  </div>
                </CardBody>
                <CardBody className="pt-0">
                  <hr />
                  <div className="d-flex justify-content-center mt-5">
                    <div className="circle d-flex flex-column align-items-center me-5">
                      <span>75</span>
                      <h6>Applications</h6>
                    </div>
                    <div className="circle d-flex flex-column align-items-center me-5">
                      <span>80</span>
                      <h6>New</h6>
                    </div>
                    <div className="circle d-flex flex-column align-items-center me-5">
                      <span>65</span>
                      <h6>Viewed</h6>
                    </div>
                    <div className="circle d-flex flex-column align-items-center">
                      <span>10</span>
                      <h6>Shortlisted</h6>
                    </div>
                  </div>
                </CardBody>
              </Card>
            ))
          ) : (
            <CardBody className="pt-0">
              <h4>No Jobs Available!</h4>
            </CardBody>
          )}
        </div>
      </Container>
    </div>
  );
};

export default EmpDashboard;
